export default __webpack_public_path__ + "9c49a63a3255c9f43c3ddf7783a9819f.png";